export default __webpack_public_path__ + "fonts/iconfont.ee37bac21f031f0fdd8047b9cd90872e.eot";